var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 1.83329H13V0.999959C13 0.541626 12.625 0.166626 12.1667 0.166626C11.7083 0.166626 11.3333 0.541626 11.3333 0.999959V1.83329H4.66667V0.999959C4.66667 0.541626 4.29167 0.166626 3.83333 0.166626C3.375 0.166626 3 0.541626 3 0.999959V1.83329H2.16667C1.24167 1.83329 0.508333 2.58329 0.508333 3.49996L0.5 15.1666C0.5 16.0833 1.24167 16.8333 2.16667 16.8333H13.8333C14.75 16.8333 15.5 16.0833 15.5 15.1666V3.49996C15.5 2.58329 14.75 1.83329 13.8333 1.83329ZM13.8333 14.3333C13.8333 14.7916 13.4583 15.1666 13 15.1666H3C2.54167 15.1666 2.16667 14.7916 2.16667 14.3333V5.99996H13.8333V14.3333ZM3.83333 7.66663H5.5V9.33329H3.83333V7.66663ZM7.16667 7.66663H8.83333V9.33329H7.16667V7.66663ZM10.5 7.66663H12.1667V9.33329H10.5V7.66663Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.c424ae32.svg";
export { ForwardRef as ReactComponent };